import OneTimeOrder from './OneTimeOrder';

export default OneTimeOrder;
